// @ts-nocheck
import * as Types from '../../../../__generated/treasury/types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentV2PageQueryVariables = Types.Exact<{
  productFilter: Types.TreasuryProductFilter;
  battlePassInput?: Types.InputMaybe<Types.BattlePassInput>;
  allowedActionsInput: Types.TreasuryPaymentsCustomerActionsFilter;
}>;

export type PaymentV2PageQuery = {
  __typename: 'Query';
  treasury?: {
    __typename: 'TreasuryQuery';
    id: string;
    payments?: {
      __typename: 'TreasuryPaymentsQuery';
      product: {
        __typename: 'TreasuryProductPayload';
        error?:
          | { __typename: 'TreasuryPaymentsBadRequestError'; message?: string | null }
          | { __typename: 'TreasuryPaymentsPaymentError'; message: string }
          | { __typename: 'TreasuryPaymentsUnauthenticatedError'; message?: string | null }
          | { __typename: 'TreasuryPaymentsUnknownError'; message?: string | null }
          | null;
        data?:
          | {
              __typename: 'TreasuryProductAdFree';
              plans?: Array<{
                __typename: 'TreasuryPaymentsPlan';
                id: string;
                name: string;
                basePrice: { __typename: 'TreasuryPaymentsMoney'; amount: number; currency: string };
              }> | null;
            }
          | {
              __typename: 'TreasuryProductBattlePass';
              id: string;
              name?: string | null;
              description?: string | null;
              iconUrl?: string | null;
              prices?: Array<{
                __typename: 'TreasuryPaymentsPrice';
                id: string;
                basePrice: { __typename: 'TreasuryPaymentsMoney'; amount: number; currency: string };
              }> | null;
              bundles?: Array<{
                __typename: 'TreasuryPaymentsBundle';
                id: string;
                plan?: {
                  __typename: 'TreasuryPaymentsPlan';
                  id: string;
                  name: string;
                  basePrice: { __typename: 'TreasuryPaymentsMoney'; amount: number; currency: string };
                  finalPrice: { __typename: 'TreasuryPaymentsMoney'; amount: number; currency: string };
                  appliedCoupon?: { __typename: 'TreasuryPaymentsCoupon'; name: string } | null;
                } | null;
              }> | null;
            }
          | {
              __typename: 'TreasuryProductPlus';
              plans?: Array<{
                __typename: 'TreasuryPaymentsPlan';
                id: string;
                name: string;
                basePrice: { __typename: 'TreasuryPaymentsMoney'; amount: number; currency: string };
              }> | null;
            }
          | {
              __typename: 'TreasuryProductXPBooster';
              id: string;
              name?: string | null;
              description?: string | null;
              iconUrl?: string | null;
              prices?: Array<{
                __typename: 'TreasuryPaymentsPrice';
                id: string;
                basePrice: { __typename: 'TreasuryPaymentsMoney'; amount: number; currency: string };
              }> | null;
              battlePass: { __typename: 'TreasuryProductBattlePass'; id: string };
            }
          | null;
      };
      customer?:
        | {
            __typename: 'TreasuryPaymentsCustomer';
            id: string;
            billingInfo?:
              | {
                  __typename: 'TreasuryPaymentsBillingInfo';
                  paypal?: { __typename: 'TreasuryPaymentsPayPal'; email: string } | null;
                  stripe?: {
                    __typename: 'TreasuryPaymentsStripe';
                    card: { __typename: 'TreasuryPaymentsCard'; last4: string; name: string };
                    billing: {
                      __typename: 'TreasuryPaymentsBillingAddress';
                      country: string;
                      state: string;
                      city: string;
                      line1: string;
                      zip: string;
                    };
                  } | null;
                  stripePaymentMethod?: {
                    __typename: 'TreasuryPaymentsStripePaymentMethod';
                    displayName: string;
                    type: string;
                  } | null;
                }
              | { __typename: 'TreasuryPaymentsUnknownError' }
              | null;
            allowedActions?: Array<
              | { __typename: 'TreasuryPaymentCustomerActionCancelSubscription' }
              | {
                  __typename: 'TreasuryPaymentCustomerActionChangeSubscription';
                  isAllowed: boolean;
                  product: Types.TreasuryPaymentsProduct;
                }
              | {
                  __typename: 'TreasuryPaymentCustomerActionCreateSubscription';
                  isAllowed: boolean;
                  product: Types.TreasuryPaymentsProduct;
                }
              | {
                  __typename: 'TreasuryPaymentCustomerActionRenewSubscription';
                  isAllowed: boolean;
                  product: Types.TreasuryPaymentsProduct;
                }
              | { __typename: 'TreasuryPaymentCustomerActionUseTrial' }
            > | null;
          }
        | { __typename: 'TreasuryPaymentsUnauthenticatedError' }
        | { __typename: 'TreasuryPaymentsUnknownError' }
        | null;
    } | null;
  } | null;
  battlePass: {
    __typename: 'BattlePassQuery';
    id: string;
    battlePass: {
      __typename: 'BattlePassPayload';
      error?: Types.BattlePassGetError | null;
      errorMsg?: string | null;
      data?: {
        __typename: 'BattlePass';
        id: string;
        name: string;
        enrollment?: {
          __typename: 'BattlePassEnrollment';
          id: string;
          rewardsAccess: Types.BattlePassRewardsAccess;
        } | null;
      } | null;
    };
  };
};

export const PaymentV2PageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaymentV2PageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productFilter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryProductFilter' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'battlePassInput' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BattlePassInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'allowedActionsInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsCustomerActionsFilter' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'treasury' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'productFilter' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'error' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'TreasuryProductPlus' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'plans' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'basePrice' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'TreasuryProductAdFree' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'plans' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'basePrice' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'TreasuryProductBattlePass' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'PaymentV2ProductBattlePassFragment' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'TreasuryProductXPBooster' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'PaymentV2ProductXPBoosterFragment' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'TreasuryPaymentsCustomer' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'billingInfo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: { kind: 'Name', value: 'TreasuryPaymentsBillingInfo' },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'paypal' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'PaypalBillingInfoFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'stripe' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'StripeBillingInfoFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'stripePaymentMethod' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allowedActions' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'filter' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'allowedActionsInput' },
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'TreasuryPaymentCustomerActionCreateSubscription',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'isAllowed' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'TreasuryPaymentCustomerActionChangeSubscription',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'isAllowed' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value: 'TreasuryPaymentCustomerActionRenewSubscription',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'isAllowed' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'product' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'battlePass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'battlePass' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'battlePassInput' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMsg' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'enrollment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rewardsAccess' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentV2ProductBattlePassFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryProductBattlePass' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'basePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bundles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'basePrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalPrice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appliedCoupon' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentV2ProductXPBoosterFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryProductXPBooster' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'iconUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'basePrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'battlePass' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaypalBillingInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsPayPal' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'email' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StripeBillingInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsStripe' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'card' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePaymentV2PageQuery__
 *
 * To run a query within a React component, call `usePaymentV2PageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentV2PageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentV2PageQuery({
 *   variables: {
 *      productFilter: // value for 'productFilter'
 *      battlePassInput: // value for 'battlePassInput'
 *      allowedActionsInput: // value for 'allowedActionsInput'
 *   },
 * });
 */
export function usePaymentV2PageQuery(
  baseOptions: Apollo.QueryHookOptions<PaymentV2PageQuery, PaymentV2PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentV2PageQuery, PaymentV2PageQueryVariables>(PaymentV2PageQueryDocument, options);
}
export function usePaymentV2PageQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PaymentV2PageQuery, PaymentV2PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaymentV2PageQuery, PaymentV2PageQueryVariables>(PaymentV2PageQueryDocument, options);
}
export type PaymentV2PageQueryHookResult = ReturnType<typeof usePaymentV2PageQuery>;
export type PaymentV2PageQueryLazyQueryHookResult = ReturnType<typeof usePaymentV2PageQueryLazyQuery>;
export type PaymentV2PageQueryQueryResult = Apollo.QueryResult<PaymentV2PageQuery, PaymentV2PageQueryVariables>;
